<template>
  <div class="project">
    <div class="titleBar">
      <PlateTitle
        title="订单列表"
        class="plate"
      />
    </div>
    <!-- <a-menu
      v-model="current"
      mode="horizontal"
      @click="handleClick"
    >
      <a-menu-item key="1">
        标段保证保险
      </a-menu-item>
      <a-menu-item
        key="2"
      >
        低价差额担保保函
      </a-menu-item>
    </a-menu> -->
    <div class="search">
      <img
        src="@/assets/image/icon-ss.png"
        alt=""
      >
      <a-input
        v-model="query.keywords"
        placeholder="输入关键词搜索"
      />
      <a-button
        type="primary"
        @click="toQuery"
      >
        查询
      </a-button>
      <a-button
        type="primary"
        @click="reset"
      >
        重置
      </a-button>
    </div>
    <!-- <div class="bid">
      <a-tabs
        v-model="activeKey"
        @change="callback"
      >
        <a-tab-pane
          v-for="(item,index) in bidStatus"
          :key="index"
          :tab="item"
        />
      </a-tabs>
    </div> -->
    <div class="bid">
      <!-- <a-radio-group style="margin-bottom: 16px">
        <a-radio-button
          v-for="(item,index) in bidType"
          :class="{active: index===activeType}"
          :key="index"
          :value="item"
          @click="handleChange(index)"
        >
          {{ item }}
        </a-radio-button>
      </a-radio-group> -->
      <!-- <a-tabs
        v-model="activeKey"
        @change="callback"
      >
        <a-tab-pane
          v-for="(item,index) in bidType"
          :key="index"
          :tab="item"
        />
      </a-tabs> -->
      <!-- <ul>
          <li
            v-for="(item,index) in bidStatus"
            :key="index"
            :class="{active:currentClass===index}"
            @click="toggleTab(index)"
          >
            {{ item }}
          </li>
        </ul> -->
    </div>

    <!-- 表格 -->
    <div class="table">
      <a-list
        item-layout="vertical"
        size="large"
        :pagination="isPagination ? pagination : null"
        :data-source="orderList"
        :loading="loading"
      >
        <a-list-item
          slot="renderItem"
          key="item.title"
          slot-scope="item"
        >
          <div class="forTable">
            <!-- <div class="top">
              <span class="top1">{{ item.bidsectionName }}</span>
              <p class="top3">
                {{ item.bidsectionCode }}
              </p>
            </div> -->
            <div class="bottom">
              <div class="div1">
                <p>标段名称</p>
                <p>{{ item.bidsectionName }}</p>
              </div>
              <div class="div2">
                <p>标段ID</p>
                <p>
                  {{ item.bidsectionCode }}
                </p>
              </div>
              <div class="div3">
                <p>支付截止时间</p>
                <p>{{ item.bidOpenTime.slice(0, 10) + " 00:00:00" }}</p>
              </div>
              <div style="width: 70px">
                <p>金融机构</p>
                <p>{{ item.curInsuranceName }}</p>
              </div>
              <!-- <div
                class="div5"
                v-show="activeKey===0"
              >
                <p>保额</p>
                <p>￥{{ item.margin }}</p>
              </div> -->
              <div
                class="div5"
                v-show="activeKey === 1"
              >
                <p>保额</p>
                <p>￥{{ item.amount }}</p>
              </div>
              <div class="div6">
                <p>保费</p>
                <p>￥{{ item.premium }}</p>
              </div>
              <div class="div7">
                <p>状态</p>
                <p>{{ item.curNode | curNodeFormat }}</p>
              </div>
              <div>
                <a-button
                  type="primary"
                  v-if="
                    item.curNode !== '6' &&
                      item.curNode !== '-2' &&
                      item.curNode !== '-3'
                  "
                  @click="look(item)"
                >
                  查看
                </a-button>
              </div>
              <!-- <div>
                <a-button
                  type="primary"
                  @click="dialogFormVisible = true"
                >
                  理赔
                </a-button>
              </div>
              <el-dialog
                title="收货地址"
                :visible.sync="dialogFormVisible"
              >
                <el-form :model="form">
                  <el-form-item
                    label="活动名称"
                    :label-width="formLabelWidth"
                  >
                    <el-input
                      v-model="form.name"
                      autocomplete="off"
                    />
                  </el-form-item>
                  <el-form-item
                    label="活动区域"
                    :label-width="formLabelWidth"
                  >
                    <el-select
                      v-model="form.region"
                      placeholder="请选择活动区域"
                    >
                      <el-option
                        label="区域一"
                        value="shanghai"
                      />
                      <el-option
                        label="区域二"
                        value="beijing"
                      />
                    </el-select>
                  </el-form-item>
                </el-form>
                <div
                  slot="footer"
                  class="dialog-footer"
                >
                  <el-button @click="dialogFormVisible = false">
                    取 消
                  </el-button>
                  <el-button
                    type="primary"
                    @click="dialogFormVisible = false"
                  >
                    确 定
                  </el-button>
                </div>
              </el-dialog> -->
              <!-- <div>
                <a-button
                  type="primary"
                  v-if="true"
                  @click="apply(item)"
                >
                  申请
                </a-button>
                <a-button
                  type="primary"
                  v-else
                  class="applyed"
                >
                  已申请
                </a-button>
              </div> -->
            </div>
          </div>
        </a-list-item>
      </a-list>
    </div>
  </div>
</template>

<script>
import PlateTitle from '@/components/PlateTitle';
import { dateFormat } from '@/utils/format.js';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import {
  orderInfos,
  orderInfoGive,
  getOrderInfos,
} from '@/api/orderCenter/order.js';
export default {
  name: 'ProView',
  components: {
    PlateTitle,
  },
  filters: {
    curNodeFormat(val) {
      let valStr = '';
      switch (val) {
        case '0':
          valStr = '已注销';
          break;
        case '1':
          valStr = '未提交';
          break;
        case '2':
          valStr = '投保审核';
          break;
        case '3':
          valStr = '待支付';
          break;
        case '4':
          valStr = '已支付';
          break;
        case '5':
          valStr = '信息还原';
          break;
        case '6':
          valStr = '已取消';
          // valStr = '暂停、中止';
          break;
        case '7':
          valStr = '投保完成';
          break;
        case '8':
          valStr = '退保审核';
          break;
        case '9':
          valStr = '退保成功';
          break;
        case '10':
          valStr = '中标';
          break;
        case '-4':
          valStr = '退保失败';
          break;
        case '-3':
          valStr = '审核失败';
          break;
        case '-2':
          valStr = '订单取消';
          break;
        // case '-1':
        //   valStr = '支付失败';
        //   break;
        case '-5':
          valStr = '打款凭证审核失败';
          break;
        case '11':
          valStr = '担保审核';
          break;
        case '12':
          valStr = '银行审核';
          break;
        case '13':
          valStr = '待授权';
          break;
        case '14':
          valStr = '授权中';
          break;
        case '15':
          valStr = '授权失败';
          break;
        case '16':
          valStr = '授权成功';
          break;
        default:
          valStr = '未知状态';
      }
      return valStr;
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      // isShow: true,
      current: [ '1' ],
      // bidStatus: [ '未开标', '已开标' ],
      // bidStatus: [ '未开标' ],
      // bidType: [ '差额保函', '投标保函' ],
      activeKey: 0,
      // activeType: 0,
      dateFormat,
      locale,
      title: {},
      query: {},
      orderList: [],
      loading: false,
      isPagination: false,
      pagination: {
        onChange: page => {
          this.fetch(page);
        },
        current: 1,
        pageSize: 5,
        total: 0,
      },
      actions: [
        { type: 'star-o', text: '156' },
        { type: 'like-o', text: '156' },
        { type: 'message', text: '2' },
      ],
    };
  },
  mounted() {
    this.info({ pageSize: 5, pageNum: 1, guaranteeType: '01' });
  },
  // watch: {
  //   activeType: {
  //     handler(newType, oldType) {
  //       if (newType !== oldType) {
  //         newType === 1 ? this.getTBInfo({ pageSize: 5, pageNum: 1, guaranteeType: '01' }) :
  //           newType === 0 ? this.info({ pageSize: 5, pageNum: 1, guaranteeType: '02' }) : '';
  //       }
  //       this.isShow = newType === 0;
  //     },
  //     immediate: true,
  //   },
  // },
  methods: {
    info(params = {}) {
      orderInfos({ ...params }).then(res => {
        if (res.data.status === 'FAIL') {
          this.$message.warning(res.data.errorMsg);
          if (res.data.errorMsg === '用户未登录') {
            this.$router.push({ name: 'login' });
          }
        } else {
          res.data.recordsTotal === 0
            ? (this.isPagination = false)
            : (this.isPagination = true);
          this.orderList = res.data.data;
          this.pagination.total = res.data.recordsTotal;
        }
      });
    },
    getTBInfo(params) {
      getOrderInfos({ ...params }).then(res => {
        if (res.data.status === 'FAIL') {
          this.$message.warning(res.data.errorMsg);
        } else {
          res.data.recordsTotal === 0
            ? (this.isPagination = false)
            : (this.isPagination = true);
          this.orderList = res.data.data;
          this.pagination.total = res.data.recordsTotal;
        }
      });
    },
    fetch(page) {
      this.pagination.current = page;
      const params = {
        pageSize: 5,
        pageNum: page,
        guaranteeType: '01',
      };
      this.loading = true;
      orderInfos({ ...params }).then(res => {
        this.loading = false;
        this.orderList = res.data.data;
      });
    },
    callback() {
      if (this.activeKey === 0) {
        this.info({ pageSize: 5, pageNum: 1, guaranteeType: '02' });
      } else if (this.activeKey === 1) {
        this.getTBInfo({ pageSize: 5, pageNum: 1, guaranteeType: '01' });
      }
      // const guaranteeType = this.activeKey === 1 ? '01' : '02';
    },
    handleChange(currentIndex) {
      this.activeType = currentIndex;
    },
    handleClick(e) {
      console.log(e);
      const params = {
        pageSize: 5,
        pageNum: 1,
        guaranteeType: '02',
      };
      this.info(params);
    },
    // 查询
    toQuery() {
      this.info({
        bidsectionName: this.query.keywords,
        pageSize: 5,
        pageNum: 1,
        guaranteeType: '01',
      });
      this.pagination.current = 1;
    },
    reset() {
      this.query.keywords = null;
      this.toQuery();
    },
    look(e) {
      let insureUrl = '';
      console.log(e);
      if (e.guaranteeType === '01') {
        insureUrl = `${process.env.VUE_APP_INSURE_ZTB_HREF}/#/tenderNotice?orderNo=${e.orderNo}`;
      } else if (e.guaranteeType === '02') {
        insureUrl = `${process.env.VUE_APP_INSURE_HREF}/#/tenderNotice?orderNo=${e.orderNo}`;
      } else if (e.guaranteeType === '04') {
        insureUrl = `${process.env.VUE_APP_INSURE_HREF}/#/tenderNoticeBidding?orderNo=${e.orderNo}`;
      }
      // const insureUrl = `${process.env.VUE_APP_INSURE_HREF}/#/tenderNotice?orderNo=${e.orderNo}`;
      window.open(insureUrl);
    },
    cancel(e) {
      orderInfoGive({ orderNo: e.orderNo }).then(res => {
        if (res.data.status === 'SUCCESS') {
          this.$message.success('取消订单成功!');
          this.info({ pageSize: 5, pageNum: this.pagination.current });
        } else {
          this.$message.warning(res.data.errorMsg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.project {
  min-height: 666px;
}
.ant-radio-button-wrapper.active {
  color: #1890ff;
  border-color: #1890ff;
}
/deep/ .ant-menu-horizontal {
  border: none;
}
.search {
  display: flex;
  position: relative;
  img {
    z-index: 99;
    width: 14px;
    height: 14px;
    position: absolute;
    top: 39px;
    left: 10px;
  }
  /deep/ .ant-input-affix-wrapper {
    width: 340px;
  }
  /deep/ .ant-input {
    width: 300px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #e1e8ef;
    border-radius: 3px;
    margin: 30px 0 20px 0;
    padding-left: 40px;
  }
  button {
    margin-top: 30px;
    margin-left: 10px;
  }
}
.table {
  /deep/ .ant-list-empty-text {
    min-height: 500px;
    .ant-empty-normal {
      margin-top: 220px;
    }
  }
  /deep/ .ant-list-item {
    border-bottom: none;
    padding: 0 0 20px 0;
  }
  /deep/ .ant-spin-container > .ant-list-items > .ant-list-item:last-child {
    border: none;
  }
  /deep/ .ant-list-pagination {
    margin: 0 0 8px 0;
  }
  .top {
    width: 920px;
    height: 80px;
    background: #f7faff;
    padding: 21px 41px 17px 32px;
    position: relative;
    border: 1px solid #ebf2f7;
    border-bottom: none;
    font-family: Microsoft YaHei;
    .top1 {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
    }
    .top2 {
      font-size: 14px;
      font-weight: 400;
      color: #aaaaaa;
      position: absolute;
      right: 41px;
    }
    .top3 {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      margin-top: 5px;
    }
  }
  .bottom {
    display: flex;
    width: 920px;
    background: #ffffff;
    border: 1px solid #ebf2f7;
    padding: 25px 40px 20px 31px;
    p {
      margin: 0;
      word-wrap: break-word;
    }
    .div1 {
      width: 180px;
    }
    .div2 {
      width: 100px;
    }
    .div3 {
      width: 120px;
    }
    .div4 {
      width: 56px;
    }
    .div5 {
      width: 70px;
    }
    .div6 {
      width: 70px;
    }
    .div7 {
      width: 60px;
    }
    div {
      margin: 0 6px;
      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        &:nth-child(1) {
          color: #aaaaaa;
        }
        &:nth-child(2) {
          color: #333333;
        }
      }
      a {
        margin-right: 10px;
      }
      .applyed {
        width: 88px;
        background: #b2d7f6;
        border: #b2d7f6;
      }
    }
  }
}
</style>
